import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AppContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('admin@anvithdazzle.com');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);

  const login = async () => {
    if (!email || !password) return toast.error('Enter credentials');
    setLoading(true);
    try {
      const { data } = await API.post('/auth/admin/login', { email, password });
      loginAdmin(data.admin, data.token);
      toast.success('Welcome, Admin!');
      navigate('/admin');
    } catch {
      toast.error('Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--maroon)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: 'white', borderRadius: 4, padding: 40, width: '100%', maxWidth: 380, textAlign: 'center' }}>
        <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 28, color: 'var(--maroon)', marginBottom: 4 }}>Anvith Dazzle</div>
        <div style={{ fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', marginBottom: 32 }}>Admin Portal</div>
        <div className="form-group" style={{ textAlign: 'left' }}>
          <label className="form-label">Email</label>
          <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@anvithdazzle.com" />
        </div>
        <div className="form-group" style={{ textAlign: 'left' }}>
          <label className="form-label">Password</label>
          <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && login()} />
        </div>
        <button className="btn btn-primary btn-full btn-lg" onClick={login} disabled={loading}>
          {loading ? 'Logging in...' : 'Login to Dashboard'}
        </button>
        <p style={{ marginTop: 16, fontSize: 12, color: 'var(--text-light)' }}></p>
        <button style={{ background: 'none', border: 'none', color: 'var(--champagne)', cursor: 'pointer', marginTop: 12, fontSize: 13, fontFamily: "'Jost',sans-serif" }} onClick={() => navigate('/')}>
          ← Back to Store
        </button>
      </div>
    </div>
  );
}
